import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'precisionByNumber'
})
export class PrecisionByNumberPipe implements PipeTransform {

  transform(value?: number): number {
    return  Math.floor(Math.log10(value || 1));
  }
}
